import { Checkbox as MuiCheckbox } from '@mui/material'
import styles from './CheckBox.module.scss'
import { checkboxStyles } from './CheckBox.styles'

interface CheckBoxProps {
  label?: string
  labelSide?: 'left' | 'right'
  additionalPadding?: boolean
  onChange?: (value: boolean) => void
  value?: boolean
  field?: {
    onChange: (value: boolean) => void
    onBlur: () => void
    value: boolean
    name: string
  }
  checked?: boolean
  intermediate?: boolean
  disabled?: boolean
}

function CheckBox(props: CheckBoxProps) {
  const {
    label,
    labelSide = 'right',
    additionalPadding,
    field,
    onChange,
    value,
    checked,
    intermediate,
    disabled
  } = props

  return (
    <div
      className={`${styles.checkboxWrapper} ${
        additionalPadding ? styles.additionalPadding : ''
      }`}
    >
      {label && labelSide === 'left' && (
        <p className={`body-medium ${styles.checkboxLabel}`}>{label}</p>
      )}
      <MuiCheckbox
        sx={checkboxStyles}
        disableRipple
        onClick={() => field?.onChange(!field.value) || onChange?.(!value)}
        indeterminate={intermediate}
        checked={checked ?? field?.value ?? value ?? false}
        disabled={disabled}
        onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            if (onChange) {
              onChange(!value)
            } else if (field) {
              field?.onChange(!field.value)
            }
          }
        }}
      />
      {label && labelSide === 'right' && (
        <p className={`body-medium ${styles.checkboxLabel}`}>{label}</p>
      )}
    </div>
  )
}

export default CheckBox
